
import React, { useState, useRef, useEffect } from "react";
import "./HealthSideDrawer.css";
import userIcon from "../../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../../common/assets/images/general-surgery-icon.png";
import backIcon from "../../../../common/assets/images/back-icon.png";
import { useNavigate } from "react-router-dom";

const HealthSideDrawer = ({
  healthInsuranceManagerData,
  handleDragOver,
  handleDrop,
  hanldeSelectQueueEpisodes,
}) => {
  const [openMenu, setOpenMenu] = useState(null); // 'queues' | 'coders' | null
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mobile-qc-menu" ref={menuRef}>
      {/* <div className="mobile-qc-header">
        <img
          src={backIcon}
          alt="back"
          className="mobile-qc-back-icon"
          onClick={() => navigate("/Code-Workflow")}
        />
        <span className="mobile-qc-back-text">Back to Workflow</span>
      </div> */}

      <div className="mobile-qc-button-container">
        <button
          className={`mobile-qc-toggle-btn ${openMenu === "queues" ? "active" : ""}`}
          onClick={() => setOpenMenu(openMenu === "queues" ? null : "queues")}
        >
          Queues
        </button>
        <button
          className={`mobile-qc-toggle-btn ${openMenu === "coders" ? "active" : ""}`}
          onClick={() => setOpenMenu(openMenu === "coders" ? null : "coders")}
        >
          Coders
        </button>
      </div>

      {openMenu === "queues" && (
        <div className="mobile-qc-dropdown">
          {healthInsuranceManagerData?.queues?.map((item) => (
            <div
              key={item.queue_id}
              className="mobile-qc-item"
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, item.queue_name, "queues")}
              onClick={() => hanldeSelectQueueEpisodes("queue", item)}
            >
              <img src={generalsurgeryIcon} alt="icon" className="mobile-qc-icon" />
              <span>
                {item.queue_name} ({item.number_of_episodes}/{item.total_number_of_episodes})
              </span>
            </div>
          ))}
        </div>
      )}

      {openMenu === "coders" && (
        <div className="mobile-qc-dropdown">
          {healthInsuranceManagerData?.coders?.map((item) => (
            <div
              key={item.coder_id}
              className="mobile-qc-item"
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, item.coder_name, "coders")}
              onClick={() => hanldeSelectQueueEpisodes("coder", item)}
            >
              <img src={userIcon} alt="user" className="mobile-qc-icon" />
              <span>{item.coder_name} ({item.number_of_episodes})</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HealthSideDrawer;

